import React, { PropsWithChildren } from 'react';

type PartialLoadFilterProps = PropsWithChildren & {
    title: string;
    size?: string;
    className?: string;
};

export default class FilterContainer extends React.Component<PartialLoadFilterProps> {
    render() {
        const { size, className, children, title } = this.props;
        let itemClass = 'filters-list-item';
        if (size === 'sm') {
            itemClass += ' size-sm';
        }
        if (className) {
            itemClass += ' ' + className;
        }
        return (
            <div className={itemClass}>
                <div className="filters-list-item-title">{title}</div>
                <div className="filters-list-item-field">{children}</div>
            </div>
        );
    }
}
